export default __webpack_public_path__ + "static/media/Distinguished_Service.e1977ac7.jpg";